import Vue from "vue";
import Router, { RouteConfig, Route, NavigationGuardNext } from "vue-router";
import { UserModule } from "@/store/index";
import isIntranet from "@/utils/isIntranet";
import intranetRoutes from "@/router/international/intranetRoutes";
import extranetRoutes from "@/router/international/extranetRoutes";
import { glscLogin } from '@/utils/oauth/login/common/glscLogin'
import { euExtranetLogin } from '@/utils/oauth/login/common/euExtranetLogin'
import { checkWhitelist } from '@/api/extranet/whiteList'
// import MessageBoxImportantNotice from "@/utils/MessageBoxImportantNotice.js";

Vue.use(Router);

const baseRoutes: Array<RouteConfig> = [
  { path: "/404", component: () => import("@/views/404.vue") },
  { path: "*", redirect: "/404" },
];

// 根据内外网环境加载不同路由表
const routes: RouteConfig[] = isIntranet()
  ? baseRoutes.concat(intranetRoutes)
  : baseRoutes.concat(extranetRoutes);

const router = new Router({
  mode: "hash", // 推荐使用 history 便于埋点统计且地址栏路径较直观
  routes,
});

// 强制登录
const needLoginPathTable: Array<string> = [
  "ApiTestMainPage",
  "Apply",
  "MySystem",
  "Oauth",
];
router.beforeEach(async (to: Route, from: Route, next: NavigationGuardNext) => {
  document.documentElement.scrollTop = 0;
  UserModule.SET_CURRENT_SITE_INFO(window.location.hostname);
  if (needLoginPathTable.includes(`${to.name}`)) {
    // 关闭Loading
    UserModule.is_loading && UserModule.closeLoading();
    await UserModule.CheckLogin();
    next();
  } else {
    if (isIntranet()) {
      window.location.hash.indexOf("ticket") > -1 &&
        (await UserModule.CheckLogin());
      next();
    } else {
      const { name, query, params } = to;
      const { site } = query;
      const needSwitchSiteRouteNameList = ["AccessGuideDetail", "AccessGuide"];
      const siteList = ["us", "eu"];
      const currentRouteNameListIncludedOrNot =
        needSwitchSiteRouteNameList.includes(`${name}`);
      const currentSite = UserModule.site;
      const siteListIncludedOrNot = siteList.includes(`${site}`);

      if (currentRouteNameListIncludedOrNot && site) {
        if (siteListIncludedOrNot) {
          if (site !== currentSite) {
            UserModule.SET_SITE(`${site}`);
          }
        }
        const routerParams: any = { name, params };
        next(routerParams);
      } else if(currentSite==='eu'){
          if(window.location.hostname=='eopen.jdl.com' || window.location.hostname=='eopen-uat.jdl.com'){
              euExtranetLogin()
              next();
          }else{
              // 判断白名单
              const isWhite=await checkWhitelist(); // true
              if(!isWhite){
                  glscLogin()
                  next();
              }else{
                  // 跳转到新域名
                  if(window.env.buildEnv === 'prod'){
                      window.location.href = 'http://eopen.jdl.com/eu';
//                         window.location.href = 'http://eopen.jdl.com:8081';
                  }else{ // 预发
                      window.location.href = 'http://eopen-uat.jdl.com/eu';
//                         window.location.href = 'http://eopen.jdl.com:8081';
                  }
              }
          }
      } else if(currentSite==='us'){
          if(window.location.hostname=='eopen.jdl.com' || window.location.hostname=='eopen-uat.jdl.com'){
              if(window.env.buildEnv === 'prod'){
                window.location.href = 'http://iopen.jdl.com/us';
//                 window.location.href = 'http://iopen1.jdl.com:8080';
              }else{ // 预发
                window.location.href = 'http://uat-open.cloud.jdl.com/us';
//                 window.location.href = 'http://uat-open.cloud.jdl.com:8080';
              }
          }else{
              glscLogin()
              next();
          }
      }else {
          glscLogin()
          next();
      }
    }
  }
});

export default router;
